module.exports = __webpack_public_path__ + "img/betaaldata.1fcffd79.png";